import { GroupRoles } from "@dashboard/devices/types";
import { getRoleLabel } from "@dashboard/shared/roles";
import { Typography } from "@mui/material";

// Renders a member's role as read-only, translated text (used when the viewer cannot edit roles).
export const RoleLabel = ({ role }: { role: GroupRoles | null | undefined }) => <Typography>{getRoleLabel(role)}</Typography>;
